import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';

export interface GetCFIRetailOrdersResult {
    orders: any[];
    retailers: any[];
}

export const useGetRetailOrders = (vanityOrders: boolean, backOrders: boolean,
    closedOrders: boolean, dateFrom: Date | null) => {
    const { data, isLoading } = useQuery({
        queryKey: ['retail-orders-orders', vanityOrders, backOrders, closedOrders, dateFrom],
        queryFn: async () => await apiClient.get(`retail-order/cfi-orders`,
            {
                params: {
                    vanityOrders: vanityOrders,
                    backOrders: backOrders,
                    closedOrders: closedOrders,
                    dateFrom: dateFrom ? dateFrom.toISOString().substring(0, 10) : ''
                }
            }) as GetCFIRetailOrdersResult
    });

    return {
        data: data,
        isLoading: isLoading
    };
};
